import { useEffect, useState } from "react";
import AuthUser from "./AuthUser";
import toast, { Toaster } from "react-hot-toast";
import moment from "moment";
import { Link } from "react-router-dom";
import TaskSkeleton from "./TaskSkeleton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFile } from "@fortawesome/free-solid-svg-icons";
import Select from "react-select";
import { useCallback } from 'react';
import { debounce } from 'lodash';
import { useMemo } from 'react';


export default function StudentList() {
    const { http, user } = AuthUser();
    const [tasks, setTasks] = useState([]);
    const [TotalCount, setTotalCount] = useState();
    const [TotalCountMRP, setTotalCountMRP] = useState();
    const [date, setDate] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [departments, setdepartments] = useState([]);
    const [currentStatus, setCurrentStatus] = useState(null);
    const [loginUser, setloginUser] = useState(user.department_id);
    const [selectedStatus, setsselectedStatus] = useState();
    const [selectedStatusFinal, setsselectedStatusFinal] = useState("OPEN");
    const [selectedtp, setsselectedtp] = useState();
    const [selectedPurpose, setsselectePuropse] = useState();
    const [selectedAssigner, setsselecteAssiner] = useState();
    const [showModal, setShowModal] = useState(false);
    const [editUser, setEditUser] = useState({});
    const [cat, setCat] = useState([]);
    const [masterdata, setmasterdata] = useState([]);
    const [masterdataIndi, setMasterdataIndi] = useState([]);
    const [tasksind, setTasksInd] = useState([]);
    const [editColumn, setEditColumn] = useState(null);
    const [users, setUsers] = useState([]);

    const [stClass, setStClass] = useState([]);
    const [stDev, setstDev] = useState([]);
    const [allStudent, setAllStudent] = useState([]);
    const [selectedStud, setSelectedStudent] = useState("");
    const [selectedClassStud, setselectedClassStud] = useState("1");
    const [selectedDevStud, setselectedDevStud] = useState("");
    const [selectedDevStudType, setselectedDevStudType] = useState("");

    const [filterValues, setFilterValues] = useState({
        student: null,
        class: "",
        dev: "",
        devType: ""
    });

    const [headReceiptList, setHeadReceiptList] = useState([]);

    useEffect(() => {
        http.get(`/class?company_id=${user.company_id}`).then((res) => {
            setStClass(res.data.data);
        });

        http.get(`/student_all?company_id=${user.company_id}`).then((res) => {
            setAllStudent(res.data.data);
        });
        http.get(`/devision`).then((res) => {
            setstDev(res.data.data);
        });

        // Fetch head receipts from head_generals table
        http.get(`/head_generals?company_id=${user.company_id}`).then((res) => {
            if (Array.isArray(res.data.data)) {
                setHeadReceiptList(res.data.data);
            }
        }).catch((error) => {
            console.error("Error fetching head receipts:", error);
        });
    }, []);

    const fetchTaskDetails = (idStd, clasStd, devStd, tType) => {
        console.log(tType);
        setIsLoading(true);
        let endpoint = `/student_marks?id=${idStd}&dev=${devStd}&class=${clasStd}&type=${tType}&company_id=${user.company_id}`;

        http
            .get(endpoint)
            .then((res) => {
                setIsLoading(false);
                if (Array.isArray(res.data.data)) {
                    setTasks(res.data.data);
                    setTotalCount(res.data.total_count);
                    setTotalCountMRP(res.data.total_count_mrp);
                } else {
                    setIsLoading(false);
                    console.error("API response is not an array");
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.error("Error fetching tasks:", error);
            });
    };

    const handleHeadReceiptChange = async (studentId, headReceiptName, index) => {
        try {
            const selectedHeadReceipt = headReceiptList.find(hr => hr.name === headReceiptName);
            const alpha = selectedHeadReceipt ? selectedHeadReceipt.alpha || '' : '';

            const updateData = {
                head_receipt: headReceiptName,
                alpha: alpha
            };

            await http.put(`/student_edit/${studentId}`, updateData);
            
            // Update local state
            setTasks(prevTasks => {
                const newTasks = [...prevTasks];
                newTasks[index] = {
                    ...newTasks[index],
                    head_receipt: headReceiptName,
                    alpha: alpha
                };
                return newTasks;
            });

            toast.success("Head Receipt updated successfully!");
        } catch (error) {
            console.error("Error updating head receipt:", error);
            toast.error("Failed to update head receipt");
        }
    };
    const statusUpdate = (e) => {
        setCurrentStatus(e.target.value);
    };

    const handleSave = async (taskId) => {
        if (currentStatus === null || taskId === null) {
            toast.error("Please select proper status");
            return true;
        }
        try {
            const response = await http.put(
                `task_status_update?task_id=${taskId}&status=${encodeURIComponent(
                    currentStatus
                )}`
            );
            toast.success("Task status updated successfully !");
            fetchTaskDetails();
        } catch (error) {
            console.error("Error fetching tasks:", error);
            toast.error("Please select proper item");
        }
    };

    const initialState = {
        revised_date: "",
        revised_remark: "",
    };

    const handleChangeModal = (e) => {
        setFormData1({
            ...formData1,
            [e.target.name]: e.target.value,
        });
        if (e.target.name === "category") {
            fetchUsersForDepartment(e.target.value);
        }
        if (e.target.name === "master_id") {
            fetchMasterIndividual(e.target.value);
        }
    };

    const fetchUsersForDepartment = async (departmentId) => {
        try {
            const response = await http.get(`/master_cat?cat=${departmentId}`);
            setmasterdata(response.data.users);
        } catch (error) {
            console.error("Error fetching users:", error);
        }
    };

    const deleteTask = async (taskId) => {
        console.log(taskId);
        await http
            .delete(`/student_del/${taskId}`)
            .then((response) => {
                toast.success("Student Data Deleted successfully !");
                fetchTaskDetails();
            })
            .catch((err) => {
                console.error("Error deleting task", err);
            });
    };



    const [formData1, setFormData1] = useState({
        master_id: "",
        status: "",
        final_status: "",
    });

    const openEditModal = async (taskAll, index) => {
        setEditColumn(index);
        setShowModal(true);
        setFormData1({
            master_id: taskAll.master_id || "",
            status: taskAll.status || "",
            final_status: taskAll.final_status || "",
        });
        setEditUser(taskAll);
    };

    const closeModal = () => {
        setShowModal(false);
        setEditColumn("");
    };
    const saveEditedCustemer = async (e) => {
        e.preventDefault();
        try {
            if (!editUser) {
                // Handle the case when editUser is null
                console.error("No user data to edit.");
                return;
            }

            const response = await http.put(`/stocks_edit/${editUser.id}`, formData1);
            if (Array.isArray(response.data.data)) {
                toast.success("Stock data updated successfully!");
                setShowModal(false);
                fetchTaskDetails(selectedStatus,
                    selectedtp,
                    selectedPurpose,
                    selectedAssigner,
                    selectedStatusFinal);
            } else {
                console.log("API response is not an array");
            }
        } catch (error) {
            console.error("Error updating user", error);
            toast.error("An error occurred while updating the customer.");
        }
        setEditColumn("");
    };

    const fetchMasterIndividual = async (msterId) => {
        try {
            const response = await http.get(`/master_cat_indi?cat=${msterId}`);
            setMasterdataIndi(response.data.users);
        } catch (error) {
            console.error("Error fetching users:", error);
        }
    };

    const DropdownOption = ({ user }) => {
        return (
            <option key={user.id} value={user.id}>
                {user.item_name}
            </option>
        );
    };

    const noOptionsMessage = ({ inputValue }) => {
        if (isLoading) {
            return 'Loading...';
        } else if (!inputValue) {
            return 'Loading...';
        } else {
            return 'No options';
        }
    };


    // Inside your component
    const options = useMemo(() => {
        if (isLoading) {
            return [{ value: '', label: 'Loading...' }];
        }
        return allStudent.map((user) => ({
            value: user.id,
            label: `${user.adm_no} - ${user.ext_2}-${user.class}-${user.section}-${user.mobile}`,
        }));
    }, [allStudent, isLoading]);

    const handleSelectChange = (selectedOption) => {
        setSelectedStudent(selectedOption);
    };

    const debouncedFetchTaskDetails = useCallback(
        debounce((idStd, clasStd, devStd, tType) => {
            fetchTaskDetails(idStd, clasStd, devStd, tType);
        }, 300), // Adjust debounce delay as needed
        []
    );

    const handleSelectChangeClass = (e) => {
        const selectedValue = e.target.value;
        debouncedFetchTaskDetails(selectedStud?.value, selectedValue, selectedDevStud, selectedDevStudType);
        //setselectedClassStud(selectedValue);
    };

    const handleSelectChangeDev = (e) => {
        const selectedValueDev = e.target.value;
        setselectedDevStud(selectedValueDev);
    };

    const handleSelectChangeDevWay = (e) => {
        const selectedValueDevType = e.target.value;
        setselectedDevStudType(selectedValueDevType);
    };

    const handleClearFields = () => {
        window.location.reload();
    };

    const handleFilterChange = (field, value) => {
        setFilterValues(prev => ({
            ...prev,
            [field]: value
        }));
    };

    const handleFilterSubmit = () => {
        const studentId = filterValues.student?.value || "";
        fetchTaskDetails(
            studentId,
            filterValues.class,
            filterValues.dev,
            filterValues.devType
        );
    };

    const isAnyFilterSelected = () => {
        return (
            filterValues.student !== null ||
            filterValues.class !== "" ||
            filterValues.dev !== "" ||
            filterValues.devType !== ""
        );
    };

    return (
        <>
            <Toaster />
            <div className="container mt-1">
                <div className="row">
                    <div className="col-8">

                        <div className="row">
                            <div className="col-4">
                                <h3 className="mb-2">
                                    Fees List
                                </h3>
                            </div>
                        </div>
                    </div>

                    <div className="row mb-2">
                        <div className="col-md-5 form-group">
                            <Select
                                options={options}
                                onChange={(value) => handleFilterChange('student', value)}
                                value={filterValues.student}
                                isDisabled={isLoading}
                                noOptionsMessage={noOptionsMessage}
                            />
                        </div>

                        <div className="col-md-2 form-group">
                            <select
                                onChange={(e) => handleFilterChange('class', e.target.value)}
                                className="form-control"
                                value={filterValues.class}
                            >
                                <option value="">Select Class</option>
                                {stClass.map((option, index) => (
                                    <option key={index} value={option.class_name}>
                                        {option.class_name}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div className="col-md-2 form-group">
                            <select
                                onChange={(e) => handleFilterChange('dev', e.target.value)}
                                className="form-control"
                                value={filterValues.dev}
                            >
                                <option value="">Select Dev</option>
                                {stDev.map((options, index) => (
                                    <option key={index} value={options.name}>
                                        {options.name}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div className="col-md-1 form-group">
                            <select
                                onChange={(e) => handleFilterChange('devType', e.target.value)}
                                className="form-control"
                                value={filterValues.devType}
                            >
                                <option value="">Type</option>
                                <option value="One-Way">One Way</option>
                                <option value="Two-Way">Two Way</option>
                            </select>
                        </div>

                        <div className="col-md-2 form-group">
                            <button onClick={handleFilterSubmit} className="btn btn-primary me-2" disabled={!isAnyFilterSelected()}>
                                Search
                            </button>
                            <Link to="" className="btn btn-success" onClick={handleClearFields}>
                                Clear
                            </Link>
                        </div>
                    </div>

                </div>

                <div className="table-responsive">
                    {isLoading ? (
                        <TaskSkeleton />
                    ) : tasks.length > 0 ? (
                        <table className="table table-striped center_tbl">
                            <thead className="table-primary">
                                <tr>
                                    <th className="text-danger">No</th>
                                    <th>Adm Date</th>
                                    <th>Adm No</th>
                                    <th>First Name</th>
                                    <th>Last Name</th>
                                    <th>Std</th>
                                    <th>Div</th>
                                    <th>Phone</th>
                                    {/* <th>Head Receipt</th> */}
                                    <th>Alpha</th>

                                    <th>Action</th>

                                    {/* Add other fields as necessary */}
                                </tr>
                            </thead>
                            <tbody>
                                {tasks.map((taskuser, index) => (
                                    <tr
                                        className={editColumn === index ? "highlight" : ""}
                                        key={taskuser.id}
                                    >
                                        <td>{index + 1}</td>
                                        <td width="11%">
                                            {moment(taskuser.adm_date).format("DD MMM,YYYY")}</td>
                                        <td className="">{taskuser.adm_no}</td>
                                        <td className="text-uppercase">{taskuser.ext_2}</td>
                                        <td className="text-uppercase">{taskuser.ext_3}</td>
                                        <td>{taskuser.class}</td>
                                        <td>{taskuser.section}</td>
                                        <td>{taskuser.mobile}</td>
                                        {/* <td>
                                            {taskuser.head_receipt ? (
                                                <span>{taskuser.head_receipt}</span>
                                            ) : (
                                                <select 
                                                    className="form-select form-select-sm"
                                                    onChange={(e) => handleHeadReceiptChange(taskuser.id, e.target.value, index)}
                                                    defaultValue=""
                                                >
                                                    <option value="">Select...</option>
                                                    {headReceiptList.map((receipt) => (
                                                        <option key={receipt.id} value={receipt.name}>
                                                            {receipt.name}
                                                        </option>
                                                    ))}
                                                </select>
                                            )}
                                        </td> */}
                                        <td>{taskuser.alpha || '-'}</td>
                                        <td width="14%">
                                            <Link to={`/bill_list/${taskuser.id}`}
                                                className="btn  btn-sm btn-link action_link"
                                            >
                                                Pay Fees
                                            </Link>

                                            <Link to={`/student_view/${taskuser.id}`} className="btn btn-sm btn-link action_link">
                                                View
                                            </Link>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    ) : (
                        <div className="text-center p-4">
                            <p>Please use the filters above and click 'Search' to view students.</p>
                        </div>
                    )}
                </div>
            </div>
        </>
    );
}
